module.exports = __webpack_public_path__ + "static/media/pic2.4c952993.jpg";